import script from "./StudentTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudentTable.vue?vue&type=script&lang=ts&setup=true"

import "./StudentTable.vue?vue&type=style&index=0&id=48441c78&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48441c78"]])

export default __exports__